// Info Hub API Client — Proxy ueber Nginx /infohub-api/
// API-Key wird serverseitig von Nginx injiziert, kein Key im Frontend noetig

const API_BASE = "/infohub-api";

/**
 * Loest eine relative API-URL in eine vollstaendige URL auf.
 * Fuer Verwendung in <img src="...">, wo kein Header moeglich ist.
 */
export function resolveMediaUrl(path: string): string {
  return `${API_BASE}${path}`;
}

export async function apiFetch<T>(
  path: string,
  options?: RequestInit
): Promise<T> {
  const url = `${API_BASE}/api${path}`;
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(options?.headers as Record<string, string>),
  };

  const res = await fetch(url, {
    ...options,
    headers,
  });

  if (!res.ok) {
    const text = await res.text();
    let detail = text;
    try {
      const json = JSON.parse(text);
      detail = json.detail || text;
    } catch {
      if (text.includes("<html")) {
        detail = `Server-Fehler (HTTP ${res.status})`;
      }
    }
    throw new Error(detail);
  }

  return res.json();
}

/**
 * Upload-Funktion fuer Multipart/FormData (z.B. Logo-Upload).
 */
export async function apiUpload<T>(
  path: string,
  formData: FormData,
  method: string = "POST",
): Promise<T> {
  const url = `${API_BASE}/api${path}`;

  const res = await fetch(url, {
    method,
    body: formData,
  });

  if (!res.ok) {
    const text = await res.text();
    let detail = text;
    try {
      const json = JSON.parse(text);
      detail = json.detail || text;
    } catch {
      if (text.includes("<html")) {
        detail = `Server-Fehler (HTTP ${res.status})`;
      }
    }
    throw new Error(detail);
  }

  return res.json();
}
